import { Button } from '@onchainstudios/cryptoys-common-ui';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import StatusPage from '../../components/StatusPage';
import { getLegionImage, resetReservation } from '../../utils';
import JunoPonder from '../../img/zoo/JunoPonder.webp';
import { useQueryClient } from '@tanstack/react-query';
import styles from './PurchaseError.module.css';

function PurchaseError() {
  const [searchParams] = useSearchParams();
  const queryClient = useQueryClient();

  useEffect(() => {
    document.title = 'Cryptoys - Error';
  }, []);

  const clearQueries = async () => {
    await queryClient.invalidateQueries();
  };

  return (
    <>
      <StatusPage
        waveColor="red"
        legionImage={getLegionImage('fulfillmentError') ?? JunoPonder}
        contentHeading="Sorry! Something Went Wrong..."
        contentHeadingTag={
          <>
            <p className={styles.firstParagraph}>
              We’re sorry, something went wrong with this order — you didn’t get
              a Cryptoy but you were still charged 😧 Please{' '}
              <a
                href="https://support.cryptoys.com/contact/submit-request-HyByIryBq"
                style={{ textDecoration: 'underline' }}
              >
                contact us
              </a>{' '}
              so we can make this right! In the meantime, please try again, so
              you don't miss out!
            </p>
            <p>
              Please email support@cryptoys.com and include this{' '}
              <span className={`${styles.wordBreak} ${styles.noWrap}`}>
                Order ID: {searchParams.get('reservationId')}
              </span>
            </p>
          </>
        }
        buttonCont={
          <div className={styles.buttons}>
            <Button
              id="buyNowButton"
              data-testid="restart-button"
              size="large"
              onPress={async () => {
                await clearQueries();
                resetReservation(searchParams.get('dropId'));
              }}
            >
              Try Again
            </Button>
            <Button
              id="contactSupportButton"
              data-testid="contact-support-button"
              size="large"
              variant={'secondary'}
              onPress={() =>
                (window.location.href =
                  'https://support.cryptoys.com/contact/submit-request-HyByIryBq')
              }
            >
              Contact Support
            </Button>
          </div>
        }
      />
    </>
  );
}

export default PurchaseError;
